import React from "react";

const Ourservices = () => {
    return(
        <div>
           <header className>
        <nav className="navbar navbar-expand-lg">
          <div className="container">
          <img src="assets/images/la-logo-240px.png" className="la-logo" alt=""></img>
            <a className="navbar-brand" href="index.html"><h2>Lakshan Associates</h2></a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <a className="nav-link" href="/home">Home
                    <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/about">About Us</a>
                </li>
                <li className="nav-item active">
                  <a className="nav-link" href="/ourservices">Our Services</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/ourfacilities">Our Facilities</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/contactus">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
        {/* Page Content */}
        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>Our Services</h1>
                <span>We are over 6 years of experience</span>
              </div>
            </div>
          </div>
        </div>
        <div className="single-services">
          <div className="container">
            <div className="row" id="tabs">
              <div className="col-md-4">
                <ul>
                  <li><a href="#tabs-1">Employee Strength <i className="fa fa-angle-right" /></a></li>
                  <li><a href="#tabs-2">Wooden Recycling Unit<i className="fa fa-angle-right" /></a></li>
                  <li><a href="#tabs-3">Platic Recycling Unit <i className="fa fa-angle-right" /></a></li>
                  <li><a href="#tabs-4">Aluminium Recycling Unit <i className="fa fa-angle-right" /></a></li>
                </ul>
              </div>
              <div className="col-md-8">
                <section className="tabs-content">
                  <article id="tabs-1">
                    <img src="assets/images/manpower_contracts.png" alt="" />
                    <h4>Employee Strength</h4>
                    <p>We have 90 number of workers, 10 supervisors and 2 managers.
                      <br /><br />Our employee strength is the employee's overall traits and abilities to complete their goals with ease.
                      It includes the employee communication skills, technological proficiency, work ethic, problem solving and much more.</p>
                  </article>
                  <article id="tabs-2">
                    <img src="assets/images/wooden_recycling_unit.png" alt="" />
                    <h4>Wooden Recycling Unit</h4>
                    <p>Waste wood is often turned into new wooden products-such as recycled wooden flooring or garden decking. Even waste wood 
                      can aslo be shredded and stuck together with adhesives to make composite woods such as laminates.
                      <br /><br />We are making wooden pallets for packing and we are now recycle scrap woods to make new wooden pallets, 
                      new doors and new furniture's.</p>
                  </article>
                  <article id="tabs-3">
                    <img src="assets/images/plastic_recycling_unit.png" alt="" />
                    <h4>Plastic Recycling Unit</h4>
                    <p>Plastic waste recycling is the process that converts the plastic scrap into useful products. Recycling of plastic waste 
                      provides us with huge benefit in clearing the environment, saving the life of humans and animals and aslo as business 
                      opportunity.
                      <br /><br />We segregate all plastic scraps and we processing our recycling unit to produce plastic granules. Plastic 
                      granules are packed in packages and sell through out India. Our area of recycling unit is around 5000 square feet. 
                      Our plastic granules are LDPE granules, LLDPE granules, PP granules, Nylon granules and Raffia granules.</p>
                  </article>
                  <article id="tabs-4">
                    <img src="assets/images/aluminium_recycling_unit.png" alt="" />
                    <h4>Aluminium Recycling Unit</h4>
                    <p>Our aim is to enable a more circular economy through our remelt facilities, where we sort and remelt used and production
                      scrap aluminium. Aluminium is like an energy bank. Once it produced, it can be reused infinitely, and reusing post-consumer
                      aluminium scrap has a very small carbon footprint.
                      <br /><br />Currently we have only trailing with MOOSA furnace; it gives maximum yield comparing all other electrical 
                      furnaces. We have experienced persons for melting and solidifying process. Currently we are making only commercial ingots.
                      In future, we are looking for electrical furnace and alloying depending upon production and competition in the market.</p>
                  </article>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div className="callback-form callback-services">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="section-heading">
                  <h2>Request a <em>call back</em></h2>
                  <span>interdum nisl ac urna tempor mollis</span>
                </div>
              </div>
              <div className="col-md-12">
                <div className="contact-form">
                  <form id="contact" action method="post">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="name" type="text" className="form-control" id="name" placeholder="Full Name" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="email" type="text" className="form-control" id="email" pattern="[^ @]*@[^ @]*" placeholder="E-Mail Address" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="subject" type="text" className="form-control" id="subject" placeholder="Subject" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <textarea name="message" rows={6} className="form-control" id="message" placeholder="Your Message" required defaultValue={""} />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <button type="submit" id="form-submit" className="border-button">Send Message</button>
                        </fieldset>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default Ourservices;